import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type CloneDialogAccount = {
  id: string;
  name: string;
  type: string;
};

export const accountsForCloneQueryAtom = createQueryAtomFactory(
  'brokerage.accountsForClone',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    accounts: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: { offset: 0, limit: 20 },
      },
      entries: { id: true, name: true, type: true },
    },
  }),
  {
    select: (data): CloneDialogAccount[] => data?.accounts?.entries ?? [],
  },
);
